export default __webpack_public_path__ + "static/beach-easter-island-6800ff0383c65b71bec85455c901cb32.jpg";